import { type AppliedAttributeFilter } from '@/generated/graphql-types'
import { type AppliedFilters, isAppliedAttributeFilter } from '@/types/search'

export const getSelectedValues = (
  canonicalName: string,
  appliedFilters: AppliedFilters
): AppliedAttributeFilter['values'] => {
  return (
    appliedFilters?.reduce((acc: AppliedAttributeFilter['values'], curr) => {
      return curr.filterName === canonicalName && isAppliedAttributeFilter(curr) ? curr.values : acc
    }, []) || []
  )
}
